import React from "react";
import axios from "axios";
import constant from "../../constant";
import Slider from "react-slick";
import FavAction from "../FavoritesComp/FavAction";

import { connect } from "react-redux";
import { getSigleCurrency } from "../../store/actions/singleCurrencyActions";

import "./style.scss";
import { LoadingComp } from "../LoadingComp";

class FavoritesComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = { spaces: null, isLoading: true };
  }

  componentDidMount() {
    let curr = JSON.parse(localStorage.getItem("O_Auth"));
    this.props.getSigleCurrency(curr ? curr.currency : 1);

    this.fav_upd_count();
  }

  fav_upd_count = () => {
    let space_id = localStorage.getItem("favorites");
    space_id = space_id ? space_id.replace("[", "") : null;
    space_id = space_id ? space_id.replace("]", "") : null;

    let _this = this;

    if (space_id) {
      axios
        .get(`${constant.phpHost}action/favorites.php`, {
          params: {
            todo: "get_fav_spaces",
            space_id: space_id
          }
        })
        .then(function(res) {
          _this.setState({
            spaces: res.data,
            isLoading: false
          });
        });
    } else {
      _this.setState({
        isLoading: false
      });
    }
  };

  priceCalculation = price => {
    let cur_code = this.props.singleCurrency.code;
    let cur_value = this.props.singleCurrency.value;
    return this.codeOnly(cur_code) + " " + this.priceOnly(price, cur_value);
  };

  priceOnly = (price, cur_value) => {
    return (price /= cur_value).toFixed(2);
  };

  codeOnly = cur_code => {
    if (cur_code === "INR") {
      cur_code = "₹";
    }

    if (cur_code === "EUR") {
      cur_code = "€";
    }

    return cur_code;
  };

  render() {
    let { spaces, isLoading } = this.state;
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    return (
      <div className="fav_page">
        <h3 className="fav_h3">Your Favorites Spaces</h3>
        <div className="fav_spaces">
          {!isLoading ? (
            spaces ? (
              spaces.map((list, i) => (
                <div
                  id={list.id}
                  className={`row ${list.show ? "show" : ""}`}
                  key={i}
                >
                  <div className="left">
                    <a href={list.url}>
                      <Slider {...settings}>
                        {list.images.map((image, i) => (
                          <img src={image} alt="" key={i} />
                        ))}
                      </Slider>
                    </a>
                  </div>
                  <div className="right">
                    <div className="top">
                      <div className="heading">
                        <h3>
                          <a href={list.url}>{list.title}</a>
                        </h3>

                        <FavAction space_id={list.id} />
                      </div>

                      <a href={list.url} className="show_4">
                        <p>
                          <i>{list.location.place}</i>
                        </p>

                        <p className="price">
                          <strong>{this.priceCalculation(list.price)}</strong>{" "}
                          {list.isLongTerms === 1 ? (
                            <span>/{list.long_term}</span>
                          ) : (
                            <span>
                              /{list.space.type === 1 ? "day" : "hour"}
                            </span>
                          )}
                        </p>
                        <p className="upto">
                          Up to {list.space.quantity} {list.space.q_name}{" "}
                          {list.isLongTerms === 1 ? (
                            <span className="long-term">Long Term</span>
                          ) : list.discount ? (
                            <span className="discount">Discount</span>
                          ) : null}
                        </p>
                      </a>

                      <a href={list.url} className="show_1">
                        <p>
                          <span>Up to </span>
                          <span>
                            {list.space.quantity} {list.space.q_name} |{" "}
                            {list.location.place}
                          </span>
                        </p>
                        {list.isLongTerms === 1 ? (
                          <span className="long-term">Long Term</span>
                        ) : list.discount ? (
                          <div className="discount">
                            <label>Discount</label>
                            <div className="price">
                              {Object.keys(list.discount).map((price, i) => (
                                <span key={i}>
                                  {this.priceCalculation(list.discount[price])}
                                  <i> /{price}</i>
                                </span>
                              ))}
                            </div>
                          </div>
                        ) : null}
                      </a>
                    </div>
                    <div className="bottom">
                      <span className="rating" />
                      <span className="price">
                        {this.priceCalculation(list.price)}{" "}
                        {list.isLongTerms === 1 ? (
                          <i>/{list.long_term}</i>
                        ) : (
                          <i>/{list.space.type === 1 ? "day" : "hour"}</i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-result">No Favorited Listing</p>
            )
          ) : (
            <LoadingComp customStyle={{ padding: "200px 0" }} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    singleCurrency: state.singleCurrency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSigleCurrency: id => dispatch(getSigleCurrency(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoritesComp);
